import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DeviceDetail = _resolveComponent("DeviceDetail")!
  const _component_VZModal = _resolveComponent("VZModal")!

  return (_openBlock(), _createBlock(_component_VZModal, {
    title: `${_ctx.data.name ?? ''}`,
    id: `${_ctx.viewName}`,
    maxWidth: "mw-900px",
    widthClass: 'w-100 w-md-900px',
    showDialog: _ctx.showDialog,
    onModalClose: _ctx.close
  }, {
    actions: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
        disabled: _ctx.loading
      }, _toDisplayString(_ctx.t("common.close")), 9, _hoisted_1)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_DeviceDetail, {
        data: _ctx.data,
        showCard: false
      }, null, 8, ["data"])
    ]),
    _: 1
  }, 8, ["title", "id", "showDialog", "onModalClose"]))
}